import {ChakraProvider, Skeleton} from '@chakra-ui/react';
import {HaliRenderProvider, HaligatorProvider} from '@synako/haligator';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import theme from './chakra/index.ts';
import {createClient} from './halitreck-factory.js';
import {i18nConfig} from './locales/i18n-config.js';
import {toastTheme} from './chakra/components/Toast/index.ts';

import {middlewares} from '@synako/halitrek';
import {CaptureSetup} from './CaptureSetup.tsx';
import {setDefaultOptions} from 'date-fns';
import {fr} from 'date-fns/locale/fr';
import {HaliWebSocket, ReconnectInvalidationProvider} from 'ff-common';
import {getModeFromUrl} from './utils/appMode.ts';
import Hotjar from './utils/hotjar-react.ts';

// Configurer date-fns en français par défaut dès le démarrage
setDefaultOptions({locale: fr});

const locale = 'fr';

const halitreck = createClient(locale);

// Détecter le mode applicatif au démarrage depuis l'URL
// Sur /ffconnect/c/:client_id/?assistance=1 → assistance
// Sur /ffconnect/c/:client_id/ → commercial
// Sinon → client
const clientAppMode = getModeFromUrl();
halitreck.fetcher.use(middlewares.clientApp(clientAppMode)); // Ajout du header x-client-app pour que le back puisse filtrer les liens HAL selon le mode (ex: 'c:valider' masqué en mode assistance)
halitreck.fetcher.use(async (request, next) => {
  const resp = await next(request);
  // Le front peut faire une requête sur search_catalogue pour vérifier l'accès; sinon, un 403 est normal
  // /modifier-prix peut aussi retourner un 403 métier légitime (prix plancher non autorisé) qui doit être affiché en toast.
  const bypass403Redirect =
    request.url.endsWith('search_catalogue') ||
    request.url.endsWith('/modifier-prix');
  // Surtout utile quand un switch contact a été fait dans une fenêtre
  if (resp.status === 403 && !bypass403Redirect) {
    window.location.href = '/ffconnect/auth/error?error=switched';
  }
  return resp;
});

i18nConfig(locale);
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HaligatorProvider client={halitreck}>
      <Hotjar />
      <ReconnectInvalidationProvider>
        <HaliWebSocket />
        <HaliRenderProvider
          defaults={{
            skeleton: () => (
              <Skeleton
                w='100%'
                h='10'
                m='1'
              />
            ),
          }}
        >
          <ChakraProvider
            theme={theme}
            toastOptions={toastTheme}
          >
            <CaptureSetup>
              <App />
            </CaptureSetup>
          </ChakraProvider>
        </HaliRenderProvider>
      </ReconnectInvalidationProvider>
    </HaligatorProvider>
  </React.StrictMode>,
);
